import React, { FC } from 'react'
import { Tag } from '@wmgtech/legato'

import { cn } from 'shared/utils'
import { getCoverImagePath } from 'shared/utils/getCoverImagePath'

import { ArtistAvatar } from 'components'

import './SearchItem.scss'
import { SearchItemProps } from './SearchItem.props'

const SearchItem: FC<SearchItemProps> = ({
  spotifyId = '',
  facebookId = '',
  className,
  title = '',
  subtitle = '',
  isProduct = false,
  dataTestPrefix,
  isSpaceRole = false,
  zone
}) => (
  <div className={cn('search-item', className)}>
    {isProduct ? (
      <img className="search-item__avatar" alt={title || 'Product'} src={getCoverImagePath(facebookId)} />
    ) : (
      <ArtistAvatar spotifyId={spotifyId} facebookId={facebookId} className="search-item__avatar" size="xs" isImage />
    )}
    <div>
      <div className="search-item__title" data-test={`${dataTestPrefix}_artist_name`}>
        {title}{' '}
        {isSpaceRole ? (
          <Tag
            size="xs"
            removable={false}
            rounded
            text={zone?.alias ?? ''}
            colorType="dark"
            containerStyle="solid"
            tooltip
            tooltipText={zone?.name ?? ''}
          />
        ) : null}
      </div>
      <div className="search-item__info" data-test={`${dataTestPrefix}_project_name`}>
        {subtitle}
      </div>
    </div>
  </div>
)

export default SearchItem
